import React, { createContext, useContext, useState, ReactNode } from 'react';
import { BrandStatus } from '../types';

interface BrandContextType {
  brandRefresh: number;
  brandStatus: BrandStatus;
  triggerBrandRefresh: () => void;
  updateBrandStatus: (status: BrandStatus) => void;
}

const BrandContext = createContext<BrandContextType | undefined>(undefined);

export const BrandProvider: React.FC<{
  children: ReactNode;
  initialStatus?: BrandStatus;
}> = ({ children, initialStatus = BrandStatus.Active }) => {
  const [brandRefresh, setBrandRefresh] = useState<number>(Date.now());
  const [brandStatus, setBrandStatus] = useState<BrandStatus>(initialStatus);

  const triggerBrandRefresh = () => {
    setBrandRefresh(Date.now());
  };

  const updateBrandStatus = (status: BrandStatus) => {
    setBrandStatus(status);
  };

  return (
    <BrandContext.Provider
      value={{
        brandRefresh,
        brandStatus,
        triggerBrandRefresh,
        updateBrandStatus,
      }}
    >
      {children}
    </BrandContext.Provider>
  );
};

export const useBrandContext = () => {
  const context = useContext(BrandContext);
  if (context === undefined) {
    throw new Error('useBrandContext must be used within a BrandProvider');
  }
  return context;
};
